import { IQueryParams } from '@/creditflowresearch/domain/vo/IQueryParams';
import { IProduct } from '@/creditflowresearch/domain/vo/Product';
import { ProductRouteType } from '@/creditflowresearch/domain/Product/types/ProductRouteType';
import { selectProductIdsForAbsRoute } from '@/creditflowresearch/domain/Product/selectors/selectProductIdsForAbsRoute';
import { selectProductIdsForCorporateRoute } from '@/creditflowresearch/domain/Product/selectors/selectProductIdsForCorporateRoute';
import { selectProductIdsForOtherRoute } from '@/creditflowresearch/domain/Product/selectors/selectProductIdsForOtherRoute';

type RouteHandler = (
  query: IQueryParams,
  productsList: IProduct[],
  accessibleProductsIds: string[],
  hasAccess: boolean,
) => string[];

const routeHandlers: Record<ProductRouteType, RouteHandler> = {
  [ProductRouteType.ABS]: () => selectProductIdsForAbsRoute(),
  [ProductRouteType.CORPORATE]: selectProductIdsForCorporateRoute,
  [ProductRouteType.OTHER]: selectProductIdsForOtherRoute,
};

export const selectProductIdsFromQuery = (
  routeType: ProductRouteType,
  query: IQueryParams,
  productsList: IProduct[],
  accessibleProductsIds: string[],
  hasAccess: boolean,
): string[] => {
  const handler = routeHandlers[routeType];
  return handler(query, productsList, accessibleProductsIds, hasAccess);
};
